import { RoundTo3 } from "./RoundTo3";

export function XML_AddPair(x, y, cmd, xmlCanvas) {
  var s = xmlCanvas.GetStream();

  if (!isNaN(x)) x = RoundTo3(x);

  if (!isNaN(y)) y = RoundTo3(y);

  xmlCanvas.OutputElementPair(cmd, x, y, s);
}
